import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICommonListModel } from 'shared/models/Common'
import { ISortOrderEnum } from 'shared/models/List'
import {
  ApprovalHandler,
  IApprovalResponseModel,
  INewOwnerFilters,
  NewOwnersSortFieldEnum,
  NewOwnersStatusEnum,
} from '../../models/NewOwners'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'

const initialState = {
  data: null as ICommonListModel<IApprovalResponseModel> | null,
  error: null,
  loading: false,
  filters: {
    searchText: '',
    searchStatus: NewOwnersStatusEnum.All,
    sortColumn: NewOwnersSortFieldEnum.HandoverDate,
    sortOrder: ISortOrderEnum.desc,
    take: DEFAULT_PAGE_TAKE,
    skip: 0,
  } as INewOwnerFilters,

  approvalHandler: {
    data: null as ApprovalHandler | null,
    loading: true,
    error: null,
  },

  yearlyApprovals: {
    data: null as { [x: string]: number }[] | null,
    loading: false,
    error: null,
  },
}

const newOwnersSlice = createSlice({
  name: 'newOwners',
  initialState,
  reducers: {
    // Handle payload (_) for redux-saga to pickup
    fetchRequest: (state, _: PayloadAction<INewOwnerFilters>) => {
      state.loading = true
    },
    // TODO: change from any to response model
    fetchSuccess: (state, action: PayloadAction<any>) => {
      state.data = action.payload
      state.loading = false
      state.error = null
    },
    fetchError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    updateFilters: (state, action: PayloadAction<INewOwnerFilters>) => {
      state.data = null
      state.loading = true
      state.filters = action.payload
    },
    reset: (state) => {
      state.data = initialState.data
      state.error = null
      state.loading = false
    },

    fetchApproverHandlerRequest: (state) => {
      state.approvalHandler.loading = true
      state.approvalHandler.error = null
    },
    fetchApproverHandlerSuccess: (
      state,
      action: PayloadAction<ApprovalHandler>
    ) => {
      state.approvalHandler.loading = false
      state.approvalHandler.error = null
      state.approvalHandler.data = action.payload
    },
    fetchApproverHandlerError: (state, action: PayloadAction<any>) => {
      state.approvalHandler.loading = false
      state.approvalHandler.error = action.payload
    },

    fetchYearlyApprovalsRequest: (state, _: PayloadAction<number>) => {
      state.yearlyApprovals.data = null
      state.yearlyApprovals.loading = true
      state.yearlyApprovals.error = null
    },
    fetchYearlyApprovalsSuccess: (state, action: PayloadAction<any>) => {
      state.yearlyApprovals.data = action.payload
      state.yearlyApprovals.loading = false
      state.yearlyApprovals.error = null
    },
    fetchYearlyApprovalsError: (state, action: PayloadAction<any>) => {
      state.yearlyApprovals.data = null
      state.yearlyApprovals.loading = false
      state.yearlyApprovals.error = action.payload
    },
  },
})

export default newOwnersSlice
